"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Eyebrow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("./styles");
function Eyebrow(_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? 'purple' : _b;
    return (0, jsx_runtime_1.jsx)(styles_1.Container, __assign({ color: color }, { children: children }));
}
exports.Eyebrow = Eyebrow;
